import * as R from 'ramda'
import {
  RESET_PRODUCT_ROLES,
  RESET_PRODUCT_ROLES_CHANGE,
  UPDATE_PRODUCT_ROLES_CHANGE,
  UPDATE_PRODUCT_ROLES,
} from './constants'
import { createReducer } from 'helpers/ReducerUtil'

const concatByUniqUserRole = R.compose(
  R.uniqBy(R.pick(['role', 'username'])),
  R.concat
)

const filterRole = role => R.compose(
  R.not,
  R.propEq('role', role)
)

const updateProductRoles = (prevTeam, { team }) => team ? team : []

// the changes should be unique based on username values
const updateProductRolesChange = (prevTeam, { role, team }) => {
  const prev = R.filter(filterRole(role))(prevTeam)
  return role
    ? concatByUniqUserRole(prev, team)
    : concatByUniqUserRole(prevTeam, team)
}

const productRolesReducer = createReducer([], {
  [RESET_PRODUCT_ROLES]: () => [],
  [UPDATE_PRODUCT_ROLES]: updateProductRoles
})

const productRolesChangeReducer = createReducer([], {
  [RESET_PRODUCT_ROLES_CHANGE]: () => [],
  [UPDATE_PRODUCT_ROLES_CHANGE]: updateProductRolesChange
})

export {
  productRolesReducer,
  productRolesChangeReducer,
}
